var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require(("../assets/" + (this.$props.url))),"alt":"logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }